import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/site/HeroSection.css';

const HeroSection = ({ title, subtitle, description, ctaText, ctaLink, bgImage }) => {
  return (
    <section 
      className="hero-section" 
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="hero-background">
        <div className="stars-animation"></div>
        <div className="cosmic-particles"></div>
      </div>
      
      <div className="overlay"></div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-icon">✨</span>
              <span className="badge-text">Astrologia Digital</span>
            </div>
            
            <h1 className="hero-title">
              <span className="title-primary">{title}</span>
            </h1>
            
            <h2 className="hero-subtitle">{subtitle}</h2>
            
            <p className="hero-description">{description}</p>
            
            <div className="hero-cta">
              <Link to={ctaLink} className="btn btn-primary btn-hero">
                <span className="btn-icon">🚀</span>
                <span className="btn-text">{ctaText}</span>
                <span className="btn-arrow">→</span>
              </Link>
              
              <Link to="/valores" className="btn btn-outline btn-hero">
                <span className="btn-icon">💎</span>
                <span className="btn-text">Ver planos</span>
              </Link>
            </div>

            <div className="hero-features">
              <div className="feature-item">
                <span className="feature-icon">⭐</span>
                <span className="feature-text">Disponível 24/7</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🎯</span>
                <span className="feature-text">Orientações Personalizadas</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🔮</span>
                <span className="feature-text">Mapa Astral Completo</span>
              </div>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="image-container">
              <div className="floating-elements">
                <div className="element element-1">♈</div>
                <div className="element element-2">♉</div>
                <div className="element element-3">♊</div>
                <div className="element element-4">♋</div>
                <div className="element element-5">♌</div>
                <div className="element element-6">♍</div>
              </div>
              
              <img 
                src="/images/site/zodiaco.svg" 
                alt="Liv_IAm Robô Astróloga" 
                className="hero-main-image"
              />
              
              <div className="image-glow"></div>
            </div>
          </div>
        </div>
        
        <div className="hero-scroll-indicator">
          <div className="scroll-text">Role para descobrir</div>
          <div className="scroll-icon">
            <div className="scroll-wheel"></div>
            <i className="fa-solid fa-chevron-down"></i>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;